import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Link } from "react-router-dom";
import { MessageSquare, AlertTriangle, Clock, Bell, UtensilsCrossed, Calendar } from "lucide-react";

export default function Dashboard() {
  const [summary, setSummary] = useState(null);
  const [alerts, setAlerts] = useState(0);
  const [menu, setMenu] = useState(0);
  const [events, setEvents] = useState(0);

  useEffect(() => {
    api.get("/suggestions/summary").then((r) => setSummary(r.data));
    api.get("/alerts/active").then((r) => setAlerts(r.data.length));
    api.get("/menu").then((r) => setMenu(r.data.length));
    api.get("/events").then((r) => setEvents(r.data.length));
  }, []);

  return (
    <div className="space-y-6" data-testid="admin-dashboard">
      <header>
        <h1 className="font-display font-black text-3xl">Resumen</h1>
        <p className="text-muted-foreground">Estado operativo de Casa del Pueblo.</p>
      </header>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <StatCard label="Sugerencias" value={summary?.total ?? "—"} icon={MessageSquare} testid="stat-suggestions" />
        <StatCard label="Pendientes" value={summary?.pendientes ?? "—"} icon={Clock} accent testid="stat-pending" />
        <StatCard label="Urgentes" value={summary?.urgentes ?? "—"} icon={AlertTriangle} destructive testid="stat-urgent" />
        <StatCard label="Avisos activos" value={alerts} icon={Bell} testid="stat-alerts" />
        <StatCard label="Platos en carta" value={menu} icon={UtensilsCrossed} testid="stat-menu" />
        <StatCard label="Eventos" value={events} icon={Calendar} testid="stat-events" />
      </div>

      {summary && (
        <section className="bg-white rounded-2xl border border-border p-6">
          <h2 className="font-display font-bold text-lg mb-3">Sugerencias por categoría</h2>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
            {Object.entries(summary.by_category || {}).map(([cat, n]) => (
              <div key={cat} className="bg-accent rounded-xl px-3 py-2 text-sm flex justify-between">
                <span className="capitalize">{cat}</span>
                <span className="font-bold">{n}</span>
              </div>
            ))}
          </div>
        </section>
      )}

      <section className="grid sm:grid-cols-2 gap-3">
        <QuickLink to="/admin/sugerencias" label="Gestionar sugerencias" />
        <QuickLink to="/admin/avisos" label="Publicar un aviso" />
        <QuickLink to="/admin/carta" label="Editar carta" />
        <QuickLink to="/admin/mensajes" label="Aviso interno rápido" />
      </section>
    </div>
  );
}

function StatCard({ label, value, icon: Icon, accent, destructive, testid }) {
  return (
    <div
      className={`rounded-2xl border p-4 flex flex-col justify-between min-h-[100px] ${
        destructive ? "bg-destructive/10 border-destructive/30" : accent ? "bg-primary/10 border-primary/30" : "bg-white border-border"
      }`}
      data-testid={testid}
    >
      <div className="flex items-center justify-between">
        <div className="text-xs uppercase tracking-widest text-muted-foreground">{label}</div>
        <Icon size={16} className={destructive ? "text-destructive" : accent ? "text-primary" : "text-muted-foreground"} />
      </div>
      <div className="font-display font-black text-3xl">{value}</div>
    </div>
  );
}

function QuickLink({ to, label }) {
  return (
    <Link to={to} className="bg-foreground text-background rounded-2xl px-5 py-4 font-bold flex justify-between items-center hover:brightness-110 transition">
      {label}
      <span>→</span>
    </Link>
  );
}
